// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import myAccountFilterSectionStyles from "@tps/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        gap: 20,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            padding: 15px 20px 15px 15px;
        `,
    }),
};

filterStyles.headingGridItem = {
    css: css`
        display: none;
    `,
};

filterStyles.fromGridItem = filterStyles.toGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.mediumGridItem, {
        css: css`
            > div {
                display: inline-flex;
            }
        `,
    }),
};

filterStyles.datesContainer = {
    gap: 20,
};

filterStyles.orderTotalContainer = {
    gap: 20,
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.orderTotalAmountTextField = {
    ...myAccountFilterSectionStyles.orderTotalAmountTextField,
};

filterStyles.shipToGridItem = {
    width: [12, 12, 3, 4, 4],
};

filterStyles.orderNumberGridItem = {
    width: [12, 12, 3, 4, 4],
};

filterStyles.buttonsItem = {
    width: [12, 12, 6, 8, 8],
    css: css`
        justify-content: flex-end;
    `,
};

filterStyles.orderTotalGridItem = {
    width: [12, 12, 6, 4, 4],
};

filterStyles.orderTotalOperatorGridItem = {
    width: 6,
};

filterStyles.orderTotalAmountGridItem = {
    width: 6,
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
